<template>
    <section class="">
        <front-table :front_page="page"
                     :front_records="records"
                     :front_search="search"
                     :front_header="header"
                     :model="model"
                     @reload="handleReload"
                     @review="handleReview"
                     :btn_add="false"
                     :btn_delete="false"
                     :btn_edit="false"
                     :btn_review="true"
        >

            <div class="pull-right">
                <calendar-picker-filter :value="search.date_range" @change="handleCalendarChange" ></calendar-picker-filter>
            </div>
        </front-table>
        <!--编辑界面-->
        <scheduler-view :single="single" :view_mode="view_mode" @cancel="view_mode = false">
        </scheduler-view>

    </section>
</template>

<script>
    import FrontTable from "../components/front-table";
    import FrontMixins from "../common/mixins/front-mixins";
    import SchedulerView from "../components/scheduler-view";
    import CalendarPickerFilter from "@/components/calendar-picker-filter";

    export default {
        mixins: [FrontMixins],
        name: 'admin-Scheduler',
        components: {CalendarPickerFilter, SchedulerView, FrontTable},
        created() {
            this.model = 'Admin.' + this.$route.meta.model;
            this.search.date_range = [
                ((new Date()).Format('yyyy-MM-dd 00:00'))
                , ((new Date()).Format('yyyy-MM-dd 23:59'))
            ];
            this.search.use_date_range =true;
        }

    }

</script>

<style lang="scss">

</style>
